function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "m2 111 56.1546-5.333 44.6084-38.3337 55.63 17.6667 118.607-59",
  stroke: "#bf6196"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 74.2965 34.9711-13.468 96.9649 56.1715 98.555-113 44.509 113",
  stroke: "#8bc24a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2 59.7035 27-47.7035 104.936 5 98.555 113 44.509-113",
  stroke: "#ffca0f"
}));

var SvgGraphLine = function SvgGraphLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 134,
    viewBox: "0 0 279 134",
    width: 279,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraphLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graph-line.2e1a2275.svg";
export { ForwardRef as ReactComponent };